<template>
  <div class="schedular-table">
    <b-loading :is-full-page="false" :active="loading"></b-loading>
    <dynamic-scroller
      :items="tasks"
      :min-item-size="32"
      listTag="table"
      itemTag="tbody"
      class="table-scroller"
    >
      <template #before>
        <div class="thead tr">
          <div class="th" v-for="header in headers" :key="header">
            {{ header }}
          </div>
        </div>
      </template>
      <template v-slot="{ item, index, active }">
        <dynamic-scroller-item
          :item="item"
          :active="active"
          :data-index="index"
        >
          <div class="tr">
            <div
              class="td"
              :title="
                item.headerLog &&
                item.headerLog.data &&
                item.headerLog.data.order_description
                  ? item.headerLog.data.order_description
                  : ''
              "
            >
              {{
                item.headerLog &&
                item.headerLog.data &&
                item.headerLog.data.order_description
                  ? item.headerLog.data.order_description
                  : ""
              }}
            </div>
            <div class="td">
              {{ item.orderTypeCode ? item.orderTypeCode.name : "" }}
            </div>
            <div class="td">
              {{ item.orderSubtypeCode ? item.orderSubtypeCode.name : "" }}
            </div>
            <div class="td">{{ item.priority }}</div>
            <div class="td">
              {{ item.activityCode ? item.activityCode.name : "" }}
            </div>
            <div class="td">
              {{ item.failureCode ? item.failureCode.name : "" }}
            </div>
            <div class="td">
              {{ item.repairCode ? item.repairCode.name : "" }}
            </div>
            <div class="td">
              {{ item.assetFirm ? item.assetFirm.name : "" }}
            </div>
            <div class="td">
              {{ item.asset ? item.asset.thirdPartyCode : "" }}
            </div>
            <div class="td">
              {{ item.parentAsset ? item.parentAsset.thirdPartyCode : "" }}
            </div>
            <!-- <div class="td">{{ item.rate ? item.rate.code : "" }}</div> -->
            <div class="td">{{ item.rate_code || "" }}</div>
            <div class="td">
              {{ item.assetCode ? item.assetCode.name : "" }}
            </div>
            <div class="td">{{ item.frequency }}</div>
            <div class="td">
              {{ item.next_date | formatDate("DD-MMM-YYYY") }}
            </div>
            <div class="td">
              <span v-if="item.end_date">
                {{ item.end_date | formatDate("DD-MMM-YYYY") }}
              </span>
              <span v-else></span>
            </div>
            <div class="td">
              <div class="buttons" style="flex-wrap: nowrap">
                <b-button size="is-small" @click="() => $emit('edit', item)">
                  EDIT
                </b-button>
                <b-button
                  size="is-small"
                  type="is-success"
                  @click="() => $emit('restore', item.id)"
                  v-if="item.archived_at"
                >
                  RESTORE
                </b-button>
                <b-button
                  size="is-small"
                  type="is-warning"
                  @click="() => $emit('archive', item.id)"
                  v-else
                >
                  ARCHIVE
                </b-button>
              </div>
            </div>
          </div>
        </dynamic-scroller-item>
      </template>
    </dynamic-scroller>
  </div>
</template>

<script>
import { DynamicScroller, DynamicScrollerItem } from "vue-virtual-scroller";
import "vue-virtual-scroller/dist/vue-virtual-scroller.css";

export default {
  props: {
    tasks: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    DynamicScroller,
    DynamicScrollerItem,
  },
  data: () => ({
    headers: [
      "Order Description",
      "Order Type",
      "Sub Type",
      "Priority",
      "Activity Code",
      "Failure Code",
      "Repair Code",
      "Asset Firm",
      "Asset",
      "Parent Asset",
      "Rate",
      "Asset Type",
      "Frequency",
      "Next Date",
      "End Date",
      "",
    ],
  }),
};
</script>

<style lang="scss">
.schedular-table {
  position: relative;
}
.table-scroller {
  height: 53vh;

  .vue-recycle-scroller__item-wrapper {
    overflow: visible;
  }
  .thead {
    margin-bottom: 10px;
  }
  .tr {
    display: inline-flex;
    gap: 20px;
  }
  .th {
    font-weight: 600;
  }
  .th,
  .td {
    width: 150px;
    min-height: 30px;
    // overflow-wrap: break-word;
    overflow: hidden;
    white-space: nowrap;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Schedular/SchedularTable.vue